module.exports = __webpack_public_path__ + "spreadsheet.png?2d4945d336edf50551adc7820b25384d";